import { use } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../hooks/auth-redirector'

type Props = {
  children: React.ReactNode
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const user = use(AuthContext)

  if (!user.isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default AdminRoute